import React, { useContext } from "react";
import useUpdateSizeValues from "../../../Hooks/useUpdateSizeValues.js";
import useGetCurrentsTools from "../../../Hooks/useGetCurrentsTools.js";
import useGetCurrentTypeCol from "../../../Hooks/useGetCurrentTypeCol.js";
import ToolComponent from "../../ToolComponent/ToolComponent";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Header(props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const currentToolIds = globalState.state.formData.currentTool.map(item=> item.id);
  const buildStyle = useBuildStyle();
  const updateSizeValues = useUpdateSizeValues();
  const getCurrentsTools = useGetCurrentsTools();
  const getCurrentTypeCol = useGetCurrentTypeCol();
  const onDragStart = (e, template) => {
    if ( template.styles.resize)
      template.styles["resize"] = {value:"both"}
      
      e.dataTransfer.setData("controlId", JSON.stringify(template));
      e.stopPropagation();
  };
  
  const updateSize = (id, width, height) => {
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    
   
    updateSizeValues(updatedFormData, id, width, height);
   
    updateSizeValues(updatedFormData, getCurrentTypeCol(updatedFormData, [id], props.data.parent.id, "Rows"), width, height);

    updateSizeValues(updatedFormData, getCurrentTypeCol(updatedFormData, [id], props.data.parent.id, "Filter"), width, height);

    var currentsTools = [];
    getCurrentsTools(updatedFormData, currentsTools, [id]);
    updatedFormData.currentTool = currentsTools;
    
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });
  };

  const getVisibleColumn = () => {
    
    
    var visiblesColumns =  JSON.parse(JSON.stringify(props.data.metaData.filter(item => props.data.selectedValues.includes(item.id)))); 
    
    visiblesColumns.map(column => {
      column.styles["resize"] = props.draggable ? {value:"horizontal"} : {value:"none"};
      
    })
    
    return visiblesColumns;
  };

  const getStyle = () => {
    var newStyle = buildStyle(props.style);
    
    const border =  props.draggable && props.isSelected
    ? "1px dashed gray"
    : props.style.border.value
    
    newStyle["border"] = undefined
    newStyle["borderTop"] = "none";
    newStyle["borderLeft"] = "none";
    newStyle["borderRight"] = "none";
    newStyle["borderBottom"] = border;
    if (!props.draggable) newStyle["resize"] = "none"
    return newStyle;
  };
  
  return (
    <div style={getStyle()} 
     >
      <div className="selectLineCol" onClick={(e) => props.onClick(e, props.data)}>
        <div
          className="colGrid"
          style={{
            borderRight:  props.data.styles.border.value,
            width: "30px",
          }}
        ></div>
      </div>
      <div className="controlGrid">
        {getVisibleColumn().map((template) => (
          <div
            className="colGrid"
            onDoubleClick={(e) => props.onDoubleClick(e, template)}
            style={{ borderRight: props.data.styles.border.value }}
            key={template.id}>
            <ToolComponent
              position="relative"
              meta={template}
              draggable={props.draggable}
              onlyLabel={true}
              dataGridColumn={true}
              sortable={true}
              onDropColumn={(e, column) => props.onDropColumn(e, column)}
              onDragStart={(e) => onDragStart(e, template)}
              handleOnDrop={(updatedFormData,containerId, currentTemplate) => 
                props.handleOnDrop(updatedFormData,containerId, currentTemplate)}
              updateSize ={(id, resizeWidth, resizeHeight) => updateSize(template.id, resizeWidth, template.styles.height.value)}
              //onMultiselectionClick={(itemSelected) => {return}}
              onChange={(e, value) => props.onChange(e, value)}
              onKeyPress={(e) => props.onKeyPress(e)}
              onBlur={(e) => props.onBlur(e, template)} 
              //onMouseOver={(e) => props.onMouseOver(e, template)}
              onMouseEnter={(e) => props.onMouseEnter(e, template)}
              onMouseDown={(e) => props.onMouseDown(e, template)}
              onMouseLeave={(e) => props.onMouseLeave(e, template)}
              onClick={(e) => props.onClick(e, template)}/>
          </div>
        ))}
      </div>
    </div>
  );
}
